<section class="dashboard-root">
  <header class="header">
    <section class="header__left">
      <img ngSrc="/assets/images/icons/phone.svg" alt="" class="header__left-icon" height="14" width="14" />
      <a [href]="config.getSetting('tel_phone')" class="header__left-phone">{{ config.getSetting('phone') }}</a>
      <small class="header__left-text"> | {{ 'CommonTexts.openTime' | translate }}</small>
    </section>
    @if (auth.customer()) {
      <section class="header__bar">
        <div class="header__bar-welcome">
          <a [routerLink]="['/dashboard-visa/home']"
            ><img src="/assets/images/logo-figure.png" alt="" width="60" height="30" class="header__bar-welcome-logo"
          /></a>
          <span
            >{{ 'DashboardView.text1' | translate }}, {{ auth.user.first_name | uppercase }}
            {{ auth.user.last_name | uppercase }}!</span
          >
        </div>
        <nav class="header__bar-nav">
          <a [routerLink]="['/dashboard-visa/profile']" class="header__bar-link">
            <img
              ngSrc="/assets/images/icons/settings.svg"
              alt=""
              class="header__bar-link-icon"
              height="14"
              width="13"
            />
            {{ 'DashboardView.text2' | translate }}
          </a>
          @if (loading()) {
            <span class="header__bar-link"
              ><app-loading [showSmall]="true" [showText]="true" [showInline]="true"
            /></span>
          } @else {
            <a href="#" (click)="logout(); $event.preventDefault()" class="header__bar-link" id="logoutButton">
              <img
                ngSrc="/assets/images/icons/logout.svg"
                alt=""
                class="header__bar-link-icon"
                height="11"
                width="14"
              />
              {{ 'DashboardView.text3' | translate }}
            </a>
          }
        </nav>
      </section>
    }
  </header>

  <main [class.main]="auth.customer()">
    @if (auth.customer()) {
      <nav class="navigation">
        <a [routerLink]="['/dashboard-visa/home']" class="navigation__logo"
          ><img ngSrc="/assets/images/logo-figure.png" width="60" height="30" alt=""
        /></a>
        <section class="navigation__links">
          <a
            [routerLink]="['/dashboard-visa/home']"
            routerLinkActive="active"
            #rlaHome="routerLinkActive"
            class="navigation__link"
            [class.navigation__link_active]="rlaHome.isActive"
          >
            <img
              [src]="'assets/images/icons/dashboard' + (rlaHome.isActive ? '-active.svg' : '.svg')"
              class="navigation__icon"
              height="36"
              alt=""
            /><span class="navigation__link-text">{{ 'DashboardView.linkHome' | translate }}</span></a
          >
          @if (cardMenuVisible$ | async) {
            <a
              [routerLink]="['/dashboard-visa/transactions']"
              routerLinkActive="active"
              #rlaTransactions="routerLinkActive"
              class="navigation__link"
              [class.navigation__link_active]="rlaTransactions.isActive"
            >
              <img
                [src]="'assets/images/icons/transactions' + (rlaTransactions.isActive ? '-active.svg' : '.svg')"
                class="navigation__icon"
                height="36"
                alt=""
              /><span class="navigation__link-text">{{ 'DashboardView.linkTransactions' | translate }}</span></a
            >
          }
          <a
            [routerLink]="['/dashboard-visa/invoices']"
            routerLinkActive="active"
            #rlaInvoices="routerLinkActive"
            class="navigation__link"
            [class.navigation__link_active]="rlaInvoices.isActive"
          >
            <img
              [src]="'assets/images/icons/invoices' + (rlaInvoices.isActive ? '-active.svg' : '.svg')"
              class="navigation__icon"
              height="36"
              alt=""
            /><span class="navigation__link-text">{{ 'DashboardView.linkInvoices' | translate }}</span></a
          >
          <a
            [routerLink]="['/dashboard-visa/messages/inbox']"
            routerLinkActive="active"
            #rlaMessages="routerLinkActive"
            class="navigation__link position-relative"
            [class.navigation__link_active]="rlaMessages.isActive"
          >
            @let unreadMessages = globalService.unreadMessagesNumber();
            @if (unreadMessages) {
              <span class="position-absolute top-90 start-100 translate-middle badge bg-danger">{{
                unreadMessages
              }}</span>
            }
            <img
              [src]="'assets/images/icons/messages' + (rlaMessages.isActive ? '-active.svg' : '.svg')"
              class="navigation__icon"
              height="36"
              alt=""
            /><span class="navigation__link-text">{{ 'DashboardView.linkMessages' | translate }}</span></a
          >
          @if (cardMenuVisible$ | async) {
            <a
              [routerLink]="['/dashboard-visa/card']"
              routerLinkActive="active"
              #rlaCreditCard="routerLinkActive"
              class="navigation__link"
              [class.navigation__link_active]="rlaCreditCard.isActive"
            >
              <img
                [src]="'assets/images/icons/credit-card' + (rlaCreditCard.isActive ? '-active.svg' : '.svg')"
                class="navigation__icon"
                height="36"
                alt=""
              /><span class="navigation__link-text">{{ 'DashboardView.linkCard' | translate }}</span></a
            >
          }
          <a
            [routerLink]="['/dashboard-visa/help']"
            routerLinkActive="active"
            #rlaSupport="routerLinkActive"
            class="navigation__link"
            [class.navigation__link_active]="rlaSupport.isActive"
          >
            <img
              [src]="'assets/images/icons/help' + (rlaSupport.isActive ? '-active.svg' : '.svg')"
              class="navigation__icon"
              height="36"
              alt=""
            /><span class="navigation__link-text">{{ 'DashboardView.linkHelp' | translate }}</span></a
          >
        </section>
      </nav>
    }

    <div class="container-fluid pt-0 pt-md-6">
      <!--@let notification = serviceNotification();
      @if (notification && notification.dashboard) {
        <div class="alert alert-warning container">
          {{ notification.message }}
        </div>
      }-->
      <router-outlet />

      <footer class="footer">
        <section class="footer__contacts">
          <a [href]="config.getSetting('tel_phone')" class="footer__contacts-phone mb-2 mb-sm-0">
            <img src="/assets/images/icons/phone.svg" height="18" alt="" class="footer__contacts-icon" />
            {{ config.getSetting('phone') }}
          </a>
          <small class="footer__contacts-text"
            ><small class="header__left-text"> | {{ 'CommonTexts.openTime' | translate }}</small></small
          >
        </section>
        <address class="footer__address">
          <div class="footer__address-item">{{ config.getSetting('brandName') }}</div>
          <div class="footer__address-item">
            {{ config.getSetting('companyAddress') }}, {{ config.getSetting('companyPostalCode') }}
            {{ config.getSetting('companyCity') }}
          </div>
          <div class="footer__address-item">
            {{ 'CommonTexts.businessId' | translate }}: {{ config.getSetting('companyId') }}
          </div>
        </address>
        <nav class="footer__nav">
          <a [href]="config.getSetting('mailto_email')" class="footer__nav-item">{{ config.getSetting('email') }}</a>
        </nav>
      </footer>
    </div>
  </main>
</section>
